import { render, staticRenderFns } from "./DatePickerField.vue?vue&type=template&id=5358c5f4&scoped=true"
import script from "./DatePickerField.vue?vue&type=script&lang=js"
export * from "./DatePickerField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5358c5f4",
  null
  
)

export default component.exports